import { useApiRequestHelper } from '@/composables/useApiRequestHelper.js'
import { GetConfig } from '@expansivefm/api-request-parser'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

export const useWorkOrderStore = defineStore(
  'workOrder',
  () => {
    const { $apiAuthenticatedRequest } = useApiRequestHelper()

    const { t } = useI18n()

    const workOrder = ref(null)

    const fetchWorkOrders = async (filters = {}, page = 1, pageSize = 10) => {
      return await $apiAuthenticatedRequest.index(
        'work-orders',
        $apiAuthenticatedRequest.configs.index
          .setSort('created_at')
          .setDirection(GetConfig.DESCENDING)
          .setFilters(filters)
          .setPageSize(pageSize)
          .setPage(page),
      )
    }

    const fetchWorkOrder = async (workOrderId, includes = []) => {
      return await $apiAuthenticatedRequest.get(
        'work-orders',
        $apiAuthenticatedRequest.configs.get.setId(workOrderId).setIncludes(includes),
      )
    }

    const reset = () => {
      workOrder.value = null
    }

    return {
      workOrder,
      fetchWorkOrders,
      fetchWorkOrder,
      reset,
    }
  },
  { persist: true },
)
